// 企业相关全部请求
import environment from '../../config/environment'
import { getSafeListAPI, getSafeListDetailAPI } from '../api'
import { encrypt } from '../common'
import qs from 'qs'

// 常量
const API_CODE = environment.safeCode
const API_KEY = environment.safeKey

// 企业列表查询
function getSafeList(paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })

    // const params = qs.stringify({
    //     code: API_CODE,
    //     token: token,
    //     param: encrypt(paramStr, API_CODE, API_KEY)
    // })
    return getSafeListAPI(params)
}
// 企业列表详情
function getSafeListDetail(paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })

    // const params = qs.stringify({
    //     code: API_CODE,
    //     token: token,
    //     param: encrypt(paramStr, API_CODE, API_KEY)
    // })
    return getSafeListDetailAPI(params)
}

export { getSafeList, getSafeListDetail }



// WEBPACK FOOTER //
// ./src/request/index/safeServer.js